// Supported currencies: code → { symbol, name }
export const CURRENCIES = {
  USD: { symbol: '$',   name: 'US Dollar' },
  EUR: { symbol: '€',   name: 'Euro' },
  GBP: { symbol: '£',   name: 'British Pound' },
  INR: { symbol: '₹',   name: 'Indian Rupee' },
  CAD: { symbol: 'C$',  name: 'Canadian Dollar' },
  AUD: { symbol: 'A$',  name: 'Australian Dollar' },
  AED: { symbol: 'د.إ', name: 'UAE Dirham' },
  SGD: { symbol: 'S$',  name: 'Singapore Dollar' },
  JPY: { symbol: '¥',   name: 'Japanese Yen' },
  CNY: { symbol: '¥',   name: 'Chinese Yuan' },
  HKD: { symbol: 'HK$', name: 'Hong Kong Dollar' },
  KRW: { symbol: '₩',   name: 'Korean Won' },
  BRL: { symbol: 'R$',  name: 'Brazilian Real' },
  MXN: { symbol: '$',   name: 'Mexican Peso' },
  ZAR: { symbol: 'R',   name: 'South African Rand' },
  NGN: { symbol: '₦',   name: 'Nigerian Naira' },
  CHF: { symbol: 'Fr',  name: 'Swiss Franc' },
  SEK: { symbol: 'kr',  name: 'Swedish Krona' },
  NOK: { symbol: 'kr',  name: 'Norwegian Krone' },
  DKK: { symbol: 'kr',  name: 'Danish Krone' },
  NZD: { symbol: 'NZ$', name: 'New Zealand Dollar' },
  IDR: { symbol: 'Rp',  name: 'Indonesian Rupiah' },
  MYR: { symbol: 'RM',  name: 'Malaysian Ringgit' },
  THB: { symbol: '฿',   name: 'Thai Baht' },
  PHP: { symbol: '₱',   name: 'Philippine Peso' },
  PKR: { symbol: '₨',   name: 'Pakistani Rupee' },
  BDT: { symbol: '৳',   name: 'Bangladeshi Taka' },
  EGP: { symbol: 'E£',  name: 'Egyptian Pound' },
  SAR: { symbol: '﷼',   name: 'Saudi Riyal' },
  QAR: { symbol: 'QR',  name: 'Qatari Riyal' },
  KWD: { symbol: 'KD',  name: 'Kuwaiti Dinar' },
};

export const DEFAULT_CURRENCY = 'USD';

// Returns the symbol for a currency code, falling back to '$'
export const getCurrencySymbol = (code) =>
  (CURRENCIES[code] || CURRENCIES[DEFAULT_CURRENCY]).symbol;
